import React, { useState, useEffect } from 'react';
import './css/Button.css'; // Style for buttons
import { t } from 'ttag';
import { mixpanel } from './mp.js';
import { Deposit } from './deposit.js';
import { Turl } from './tUrl.js'


const tg = window.Telegram ? window.Telegram.WebApp : null;

const startMonDep = async (wallet) => {
    const _userData = tg ? tg.initData : null;
    let userData = { initData: _userData, wallet: wallet }

    const response = await fetch(Turl + '/api/startMonDep', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
    });

};

function SelectDep({ handlesetIndex, setIsAuthorized, wallet, depWallet, isDoDep, setisDoDep, setErrorMessage, }) {
    const [sel, setSel] = useState(0);
    useEffect(() => {
        // Создаем элемент script
        const script = document.createElement('script');

        // Устанавливаем необходимые атрибуты
        script.src = 'https://changenow.io/embeds/exchange-widget/v2/stepper-connector.js';
        script.defer = true;
        script.type = 'text/javascript';

        // Добавляем скрипт в тело документа
        document.body.appendChild(script);

        // Функция очистки для удаления скрипта при размонтировании компонента
        return () => {
            document.body.removeChild(script);
        };
    }, []); // Пустой массив зависимостей означает, что эффект выполнится один раз


    if (sel == 0)
        return (
            <div style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start'
            }}>
                <button className="primary-button" style={{ fontSize: "x-large", marginTop: '10px', width: '70%' }} onClick={() => { setSel(1) }}>{t`USDT-BEP20`}</button>
                <button className="primary-button" style={{ fontSize: "x-large", marginTop: '10px', width: '70%' }} onClick={() => { setSel(2) }}>{t`Other Crypto`}</button>
            </div>
        );
    const src = 'https://changenow.io/embeds/exchange-widget/v2/widget.html?FAQ=true&amount=0.01&amountFiat&amountTo=&backgroundColor=2B2B35&darkMode=true&from=btc&horizontal=false&isFiat=false&lang=en-US&link_id=d0d4444c7f00ef&locales=true&logo=false&primaryColor=00C26F&to=usdtbsc&toTheMoon=false&topUpAddress=' + wallet + '&topUpCurrency=usdt&topUpExtraId&topUpMode=true&topUpNetwork=bsc'
    if (sel == 1)
        return (<Deposit handlesetIndex={handlesetIndex} setIsAuthorized={setIsAuthorized} wallet={wallet} depWallet={depWallet} isDoDep={isDoDep} setisDoDep={setisDoDep} setErrorMessage={setErrorMessage} />);
    if (sel == 2)
        return (
            <div style={{ height: '90vh', width: '100%' }}>
                <iframe
                    id='iframe-widget'
                    src={src}
                    style={{ height: '90vh', width: '100%', border: 'none' }}>
                </iframe>

            </div>);

}

export { SelectDep };